module.exports = __webpack_public_path__ + "img/112.cd14ff87.jpg";